/**
 * Support contact — single source of truth for the web client.
 *
 * The browser can't read backend env vars, so this mirrors the default in
 * `api_backend_fastify_server/src/constants/support.ts`. It can still be
 * overridden at build time via `VITE_SUPPORT_EMAIL` if a deployment needs a
 * different address before the real mailbox is live.
 *
 * Used for the `mailto:` links on the Support page and as the fallback shown
 * to users when the in-app support form is unavailable. See
 * `docs/support-email-setup.md` for the Resend inbound setup behind the
 * address.
 */

/** Address users contact for help. */
export const SUPPORT_EMAIL: string =
  (import.meta.env.VITE_SUPPORT_EMAIL as string | undefined)?.trim() ||
  'support@highcallrodeo.com';

/** A ready-to-use `mailto:` href for the support address. */
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
